import {Alert, Button, Card, Divider, Form, Input, Spin} from 'antd';
import React from "react";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";

class Create extends React.Component {
  componentDidMount() {
    const {match, fetch} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      // disabled
      // this.props.onSubmit(values, this.props.service);
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {loading, title, data} = this.props;

    return (
      <Spin spinning={loading}>
        <Alert
          message="Feature disabled"
          description="This feature is disabled at this moment!"
          type="error" showIcon/>
        <Divider/>
        <Card className={`gx-card-metrics`} title={`SMTP ${title}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <Form.Item key={'host'} label={'Host'}>
              {getFieldDecorator('host', {
                rules: [{required: true, message: 'Host is required!'}],
                initialValue: data && data.host || ''
              })(<Input/>)
              }
            </Form.Item>
            <Form.Item key={'port'} label={'Port'}>
              {getFieldDecorator('port', {
                rules: [{required: true, message: 'Port is required!'}],
                initialValue: data && data.port || ''
              })(<Input/>)
              }
            </Form.Item>
            <Form.Item key={'username'} label={'Username'}>
              {getFieldDecorator('username', {
                rules: [{required: true, message: 'Username is required!'}],
                initialValue: data && data.username || ''
              })(<Input/>)
              }
            </Form.Item>
            <Form.Item key={'password'} label={'Password'}>
              {getFieldDecorator('password', {
                rules: [{required: true, message: 'Password is required!'}],
                initialValue: data && data.password || ''
              })(<Input.Password type={'password'}
                                 iconRender={visible => (visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>)}/>)
              }
            </Form.Item>
            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create()(Create);
export default CreateForm;
